import { Subject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { SuperAggregatorDashboardModel } from '../../shared/models/super-aggregator.model';
import { LocalStorageService } from './local-storage.service';
import { AppConfig } from '../../shared/config/app-config';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SuperAggregatorService {

	public monitorGrafanaUrl: Subject<string> = new ReplaySubject();
	public featureAccess: Subject<string[]> = new ReplaySubject(1);
	public coordinatorState: Subject<string> = new ReplaySubject<string>(1);

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
		private localStorage: LocalStorageService
	) {
	}

	getDashboardData(): Promise<SuperAggregatorDashboardModel> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/dashboard/super-aggregators?trend=3`;
		return this.apiClientHelper.getForPromise(url);
	}
}
